(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sa-about-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('about-hero-slideshow')) {
    class AboutHeroSlideshow extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-about-hero-track]');
        this.slides = Array.from(this.querySelectorAll('[data-about-hero-slide]'));

        if (!this.track || this.slides.length < 2) return;

        this.currentIndex = 0;
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.intervalDuration = (Number(this.dataset.interval) || 5) * 1000;
        this.userPaused = false;
        this.motionOverride = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.previousButton = this.querySelector('[data-about-hero-previous]');
        this.nextButton = this.querySelector('[data-about-hero-next]');
        this.autoplayButton = this.querySelector('[data-about-hero-autoplay]');
        this.status = this.querySelector('[data-about-hero-status]');
        this.dots = Array.from(this.querySelectorAll('[data-about-hero-dot]'));

        this.onPrevious = () => this.goTo(this.currentIndex - 1, true);
        this.onNext = () => this.goTo(this.currentIndex + 1, true);
        this.onVisibilityChange = () => {
          if (document.hidden) {
            this.stopAutoplay();
          } else {
            this.startAutoplay();
          }
        };
        this.onReducedMotionChange = (event) => {
          if (event.matches) {
            this.motionOverride = false;
            this.stopAutoplay();
          } else {
            this.startAutoplay();
          }
          this.updateAutoplayControl();
        };
        this.onBlockSelect = (event) => {
          const slide = event.target.closest('[data-about-hero-slide]');
          if (!slide || !this.contains(slide)) return;
          this.editorPaused = true;
          this.stopAutoplay();
          this.goTo(Number(slide.dataset.slideIndex));
        };
        this.onBlockDeselect = () => {
          this.editorPaused = false;
          this.startAutoplay();
        };

        this.previousButton?.addEventListener('click', this.onPrevious);
        this.nextButton?.addEventListener('click', this.onNext);
        this.autoplayButton?.addEventListener('click', () => this.toggleAutoplay());
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.aboutHeroDot), true));
        });
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.startAutoplay();
        });
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.addEventListener('shopify:block:deselect', this.onBlockDeselect);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.reducedMotion.addEventListener('change', this.onReducedMotionChange);

        this.goTo(0);
        this.updateAutoplayControl();
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.reducedMotion?.removeEventListener('change', this.onReducedMotionChange);
      }

      goTo(index, announce = false) {
        const total = this.slides.length;
        this.currentIndex = (index + total) % total;
        this.track.style.transform = `translate3d(-${this.currentIndex * 100}%, 0, 0)`;

        this.slides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex === this.currentIndex ? 'false' : 'true');
        });

        this.dots.forEach((dot, dotIndex) => {
          if (dotIndex === this.currentIndex) {
            dot.setAttribute('aria-current', 'true');
            dot.tabIndex = 0;
          } else {
            dot.removeAttribute('aria-current');
            dot.tabIndex = -1;
          }
        });

        if (announce && this.status) {
          this.status.textContent = this.slides[this.currentIndex].getAttribute('aria-label') || '';
        }
      }

      startAutoplay() {
        this.stopAutoplay();

        if (
          !this.autoplayEnabled ||
          this.userPaused ||
          this.editorPaused ||
          document.hidden ||
          (this.reducedMotion.matches && !this.motionOverride)
        ) {
          return;
        }

        this.autoplayTimer = window.setInterval(() => this.goTo(this.currentIndex + 1), this.intervalDuration);
      }

      stopAutoplay() {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = undefined;
      }

      toggleAutoplay() {
        const reducedMotionPaused = this.reducedMotion.matches && !this.motionOverride;
        const isPaused = this.userPaused || reducedMotionPaused;

        if (isPaused) {
          this.userPaused = false;
          this.motionOverride = true;
          this.startAutoplay();
        } else {
          this.userPaused = true;
          this.stopAutoplay();
        }

        this.updateAutoplayControl();
      }

      updateAutoplayControl() {
        if (!this.autoplayButton) return;

        const isPaused = this.userPaused || (this.reducedMotion.matches && !this.motionOverride);
        this.autoplayButton.classList.toggle('is-paused', isPaused);
        this.autoplayButton.setAttribute(
          'aria-label',
          isPaused ? this.autoplayButton.dataset.playLabel : this.autoplayButton.dataset.pauseLabel
        );
      }
    }

    customElements.define('about-hero-slideshow', AboutHeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-home-shop-look"] && !Shopify.designMode) return;
  try {
    
  const initializeSaHomeLook = (root) => {
    if (!root || root.dataset.lookReady === 'true') return;
    root.dataset.lookReady = 'true';
    const buttons = root.querySelectorAll('[data-look-target]');
    const panels = root.querySelectorAll('[data-look-panel]');
    const visual = root.querySelector('.sa-home-v2__shop-look-visual');
    const image = visual ? visual.querySelector(':scope > img') : null;

    const readObjectPosition = () => {
      if (!image) return { x: 50, y: 50 };
      const values = window.getComputedStyle(image).objectPosition.split(/\s+/);
      const parsePosition = (value, fallback) => {
        if (!value || !value.endsWith('%')) return fallback;
        const parsed = Number.parseFloat(value);
        return Number.isFinite(parsed) ? parsed : fallback;
      };
      return {
        x: parsePosition(values[0], 50),
        y: parsePosition(values[1] || values[0], 50)
      };
    };

    const positionHotspotsOnImage = () => {
      if (!visual || !image || !image.naturalWidth || !image.naturalHeight) return;

      const frame = visual.getBoundingClientRect();
      if (!frame.width || !frame.height) return;

      const scale = Math.max(
        frame.width / image.naturalWidth,
        frame.height / image.naturalHeight
      );
      const renderedWidth = image.naturalWidth * scale;
      const renderedHeight = image.naturalHeight * scale;
      const objectPosition = readObjectPosition();
      const offsetX = (frame.width - renderedWidth) * (objectPosition.x / 100);
      const offsetY = (frame.height - renderedHeight) * (objectPosition.y / 100);
      const mobile = window.matchMedia('(max-width: 749px)').matches;

      buttons.forEach((button) => {
        const xValue = Number.parseFloat(
          mobile ? button.dataset.hotspotXMobile : button.dataset.hotspotX
        );
        const yValue = Number.parseFloat(
          mobile ? button.dataset.hotspotYMobile : button.dataset.hotspotY
        );
        const x = Number.isFinite(xValue) ? xValue : 50;
        const y = Number.isFinite(yValue) ? yValue : 50;

        button.style.left = `${offsetX + renderedWidth * (x / 100)}px`;
        button.style.top = `${offsetY + renderedHeight * (y / 100)}px`;
      });
    };

    if (image) {
      if (image.complete) {
        window.requestAnimationFrame(positionHotspotsOnImage);
      } else {
        image.addEventListener('load', positionHotspotsOnImage, { once: true });
      }
    }

    if (visual && 'ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(() => {
        window.requestAnimationFrame(positionHotspotsOnImage);
      });
      resizeObserver.observe(visual);
    } else {
      window.addEventListener('resize', positionHotspotsOnImage, { passive: true });
    }

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        panels.forEach((panel) => {
          panel.hidden = true;
          panel.classList.remove('is-active');
        });
        const panel = root.querySelector('#' + button.dataset.lookTarget);
        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');
        if (panel) {
          panel.hidden = false;
          panel.classList.add('is-active');
        }
      });
    });
  };
  document.querySelectorAll('[data-sa-home-look]').forEach(initializeSaHomeLook);
  document.addEventListener('shopify:section:load', (event) => initializeSaHomeLook(event.target.querySelector('[data-sa-home-look]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-homepage-v2"] && !Shopify.designMode) return;
  try {
    
  const initializeSaHomeV2 = (root) => {
    if (!root || root.dataset.lookReady === 'true') return;
    root.dataset.lookReady = 'true';
    const buttons = root.querySelectorAll('[data-look-target]');
    const panels = root.querySelectorAll('[data-look-panel]');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        panels.forEach((panel) => {
          const active = panel.id === button.dataset.lookTarget;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      });
    });
  };
  document.querySelectorAll('[data-sa-home-v2]').forEach(initializeSaHomeV2);
  document.addEventListener('shopify:section:load', (event) => initializeSaHomeV2(event.target.querySelector('[data-sa-home-v2]')));

  } catch(e) { console.error(e); }
})();
})();
